import { render } from "./inputNumber.vue?vue&type=template&id=21b0f478&scoped=true"
import script from "./inputNumber.vue?vue&type=script&lang=js"
export * from "./inputNumber.vue?vue&type=script&lang=js"

import "./inputNumber.vue?vue&type=style&index=0&id=21b0f478&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\lawrenj\\source\\repos\\Bitbucket_Cloud\\tgi_friends_of_gideons_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21b0f478"]])

export default __exports__